export default __webpack_public_path__ + "locales/bg/People.json?hash=19901aef891837f5e2d623eea93164c0";